module.exports = __webpack_public_path__ + "img/logo_asiaibs.5a8dc5ce.png";